import { Suspense } from 'react';
import { PageLoadingSpinner } from 'shared/components/LoadingSpinner/PageLoadingSpinner';
import { AppRouter } from './pages/AppRouter';

function App() {
  return (
    <Suspense fallback={<PageLoadingSpinner />}>
      <AppRouter />
    </Suspense>
  );
}

export default App;
